import React from 'react';
import { TrendingUp, Eye, Bell, Shield } from 'lucide-react';

const About = () => {
  return (
    <div className="page-section">
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
          <div className="logo-icon large">B</div>
          <h2 style={{ fontSize: '28px', fontWeight: '700', color: 'var(--text-primary)', margin: 0 }}>
            Binance Analytics Pro
          </h2>
          <p style={{ fontSize: '16px', color: 'var(--text-secondary)', margin: 0 }}>
            Professional Trading Analysis Platform
          </p>
          <div style={{
            fontSize: '12px',
            color: 'var(--text-muted)',
            background: 'var(--tertiary-dark)',
            padding: '4px 12px',
            borderRadius: '12px',
            border: '1px solid var(--border-color)'
          }}>
            Version 2.1.0
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px',
          marginBottom: '40px'
        }}>
          <div className="dashboard-card">
            <div style={{
              width: '48px', height: '48px', borderRadius: '50%',
              background: 'rgba(252, 213, 53, 0.2)', color: 'var(--accent-gold)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '20px', marginBottom: '16px'
            }}>
              <TrendingUp size={20} />
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '12px' }}>
              Price Analysis
            </h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                'Daily high/low pattern analysis',
                'Interactive heatmap visualization',
                'Statistical time distribution',
                'TradingView chart integration',
                'Multiple timeframe support'
              ].map((item, index) => (
                <li key={index} style={{
                  fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '6px',
                  paddingLeft: '12px', position: 'relative'
                }}>
                  <span style={{
                    content: '•', color: 'var(--accent-gold)', position: 'absolute', left: 0
                  }}>•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="dashboard-card">
            <div style={{
              width: '48px', height: '48px', borderRadius: '50%',
              background: 'rgba(252, 213, 53, 0.2)', color: 'var(--accent-gold)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '20px', marginBottom: '16px'
            }}>
              <Eye size={20} />
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '12px' }}>
              OI Monitoring
            </h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                'Real-time Open Interest tracking',
                'Advanced anomaly detection',
                'Volume correlation analysis',
                'Discord alert integration',
                'Multi-symbol monitoring'
              ].map((item, index) => (
                <li key={index} style={{
                  fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '6px',
                  paddingLeft: '12px', position: 'relative'
                }}>
                  <span style={{
                    content: '•', color: 'var(--accent-gold)', position: 'absolute', left: 0
                  }}>•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="dashboard-card">
            <div style={{
              width: '48px', height: '48px', borderRadius: '50%',
              background: 'rgba(252, 213, 53, 0.2)', color: 'var(--accent-gold)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '20px', marginBottom: '16px'
            }}>
              <Bell size={20} />
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '12px' }}>
              Alert System
            </h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                'Real-time notifications',
                'Customizable thresholds',
                'Discord integration',
                'Alert history tracking',
                'Multiple alert types'
              ].map((item, index) => (
                <li key={index} style={{
                  fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '6px',
                  paddingLeft: '12px', position: 'relative'
                }}>
                  <span style={{
                    content: '•', color: 'var(--accent-gold)', position: 'absolute', left: 0
                  }}>•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="dashboard-card">
            <div style={{
              width: '48px', height: '48px', borderRadius: '50%',
              background: 'rgba(252, 213, 53, 0.2)', color: 'var(--accent-gold)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '20px', marginBottom: '16px'
            }}>
              <Shield size={20} />
            </div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '12px' }}>
              Security & Privacy
            </h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                'No personal data collection',
                'Local data storage only',
                'Secure API connections',
                'Open source components',
                'Privacy-first design'
              ].map((item, index) => (
                <li key={index} style={{
                  fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '6px',
                  paddingLeft: '12px', position: 'relative'
                }}>
                  <span style={{
                    content: '•', color: 'var(--accent-gold)', position: 'absolute', left: 0
                  }}>•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About